import React from 'react';
import { CenterPopup as OriginalCenterPopup } from 'antd-mobile';
const CenterPopup = (props) => {
    const { content, ...innerProps } = props;
    return (React.createElement(OriginalCenterPopup, Object.assign({}, innerProps),
        React.createElement("div", null, content)));
};
export default CenterPopup;
